import { selectJobDetailsResult } from '../jobdetails/selectors';
import { selectIsSrp } from '../location/selectors';
import type { ChaliceStore } from '../types';

import { PageKeys } from './types';

export const selectLmis = (state: ChaliceStore) => {
  const lmisKey =
    selectIsSrp(state) && !selectJobDetailsResult(state)
      ? PageKeys.SRP
      : PageKeys.JDP;

  return state.lmis[lmisKey];
};
